import { render } from "./statistical.vue?vue&type=template&id=f1cf9b2a&scoped=true&ts=true"
import script from "./statistical.vue?vue&type=script&lang=ts"
export * from "./statistical.vue?vue&type=script&lang=ts"

import "./statistical.vue?vue&type=style&index=0&id=f1cf9b2a&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1cf9b2a"]])

export default __exports__